import $ from 'jquery';
import Cookies from './modules/cookies';
import Carousel from './modules/carousel';
import Menu from './modules/menu';
import Modal from './modules/modal';
import SmoothScroll from './modules/smoothscroll';
import Accordion from './modules/accordion';

window.addEventListener('DOMContentLoaded', function(){
    Menu.run();
    Carousel.run();
    Modal.run();
    SmoothScroll.run();
    Cookies.run();
    Accordion.run();
});
